// Public contact info (single source for Footer, Contact page, About). Override via env vars.
export { publicContact } from './publicContact';

// Environment configuration
export const config = {
  apiUrl: typeof window !== 'undefined'
    ? window.location.hostname === 'localhost'
      ? 'http://localhost:3000/api'
      : (() => {
          const envUrl = import.meta.env.VITE_API_URL;
          // In production, ensure HTTPS and fallback to Railway URL
          if (!envUrl) {
            return 'https://wildy-backend-production.up.railway.app/api';
          }
          // Force HTTPS in production if URL starts with HTTP
          if (window.location.protocol === 'https:' && envUrl.startsWith('http://')) {
            return envUrl.replace('http://', 'https://');
          }
          return envUrl;
        })()
    : 'https://wildy-backend-production.up.railway.app/api',
  
  // Add other configuration values here
  defaultLocale: 'en',
  supportedLocales: ['en', 'es'],
  
  // Feature flags
  features: {
    analytics: true,
    chatbot: true,
  },
} as const;

// Type for the config
export type Config = typeof config;

// Helper function to get config values
export function getConfig<K extends keyof Config>(key: K): Config[K] {
  return config[key];
} 